import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/constantes";
import { RootState } from "@store/store";
import { ExpedienteAutorizadoFactoraje } from "@pages/producto/credito_simple/expediente_autorizado/ExpedienteAutorizadoFactoraje";
import { ExpedienteAutorizadoDefault } from "@pages/producto/credito_simple/expediente_autorizado/ExpedienteAutorizadoDefault";

/**
 * Despacha a la pantalla de expediente autorizado correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de marcador de posición.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.MERCADER_PM]: ExpedienteAutorizadoFactoraje,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE]: ExpedienteAutorizadoFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PM]: ExpedienteAutorizadoFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: ExpedienteAutorizadoFactoraje,
};

export const ExpedienteAutorizado = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || ExpedienteAutorizadoDefault;
  return <Screen />;
};
